import CompLayout from "@/pcomponents/comp/layout/layout";
import { useState, useRef, useEffect } from 'react';
import Style from "./css/style.module.css";
import FindStudentList from "@/pages/comp/basic/student/frame/left_find_list";
import CalendarArea from "./area/calendar";
import StuInfoArea from "./area/stu_info";
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import WriteCounselTodoPopup from "./area/popup/write_counsel_todo";
import ViewCounselTodoOfDay from "./area/popup/view_ctodo_day";
import DateFunc from '@/lib/lyg/date_func';
import { useNavigate } from 'react-router-dom';
import RightScrollFix from "@/pcomponents/common/content/list/right_scroll_fix";
import WriteCounselTodoArea from "@/pages/comp/basic/counsel/common/write_counsel_todo";
import SearchArea from "@/pages/comp/basic/student/list/area/search/search_area";

function CounselCalendarPage() {
  const navigate = useNavigate();
  const StuSearchListRef = useRef<any>(null);
  const CalendarAreaRef = useRef<any>(null);
  const StuInfoAreaRef = useRef<any>(null);
  const left_box_ref = useRef<any>(null);
  const left_box_scroll_ref = useRef<any>(null);
  const cal_box_ref = useRef<any>(null);
  const WriteCounselTodoAreaRef = useRef<any>(null);

  const [select_stu_arr, set_select_stu_arr] = useState<any[]>([]);
  const [content_tab, set_content_tab] = useState("calendar");//calendar,stu_info,write_counsel_todo
  const [stu_list_opt, set_stu_list_opt] = useState<any>({});
  const [popupData, setPopupData] = useState<any>({
    isOpen: false,
    sort: "write_ctodo",//view_ctodo
    stu_info_arr: [],
    start_date: "",
    end_date: "",
    select_date: "",
    list_opt: {},
    title: "보기",
    width: "900px",
    height: "100%",
  });

  useEffect(() => {
    if (StuSearchListRef.current) {
      set_stu_list_opt(StuSearchListRef.current.getListOpt());
    }
  }, []);

  const go_search_calendar = (inData: any) => {
    set_select_stu_arr(inData.s_stu_info_arr);

    if (StuInfoAreaRef.current) {
      if (inData.s_stu_info_arr.length > 0) {
        StuInfoAreaRef.current.setInitData({
          select_stu_seq: inData.s_stu_info_arr[0]["a_seq"],
        });
      }
    }
    // CalendarAreaRef.current.list({
    //   "s_stu_seq":inData.s_stu_user_seq
    // });
  };

  const go_search_user_list = (inData: any) => {
    if (StuSearchListRef.current) {
      StuSearchListRef.current.list(inData);
    }
  };

  const onSearchDateChange = (inData: any) => {
    go_search_user_list({
      "now_page": "1",
      "s_addon_counsel_start_date": DateFunc.get_date_format(DateFunc.get_change_date(new Date(inData), 'month', -1), "Y-m-01"),
      "s_addon_counsel_end_date": DateFunc.get_date_format(DateFunc.get_change_date(new Date(inData), 'month', +1), "Y-m-t"),
    });
  };

  const open_write_counsel_todo = (inData: any) => {
    let opt_obj = {
      start_date: popupData.select_date,
      end_date: popupData.select_date,
      ...inData
    };
    //inData에 start_date:"",end_date:"" 들어온다.
    // setPopupData({
    //   ...popupData,
    //   isOpen: true,
    //   sort: "write_ctodo",
    //   title: "상담일정 등록",
    //   stu_info_arr: select_stu_arr,
    //   ...opt_obj
    // });

    if (content_tab == "write_counsel_todo") {
      set_content_tab("calendar");
    } else {
      set_content_tab("write_counsel_todo");
    }
  };
  const open_view_counsel_todo = (inData: any) => {
    //inData에 select_date:"" 들어온다.
    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "view_ctodo",
      title: "상담일정 보기",
      stu_info_arr: [],
      ...inData
    });
  };
  const show_write_diary_page = (inData: any) => {
    let opt_obj = {
      stu_seq_arr: [],
      select_stu_seq: "",
      select_cousel_seq: "",
      select_date: "",
      ...inData
    };

    //학생리스트 검색 변경
    if (StuSearchListRef.current) {
      StuSearchListRef.current.list({
        "now_page": "1",
        "s_seq": opt_obj["stu_seq_arr"],
        "select_stu_seq": opt_obj["select_stu_seq"],
      });
    }

    //센터내용 학생상세탭으로 변경
    set_content_tab("stu_info");
    setTimeout(() => {
      if (StuInfoAreaRef.current) {
        StuInfoAreaRef.current.setInitData({
          "select_stu_seq": opt_obj.select_stu_seq,
          "select_cousel_seq": opt_obj.select_cousel_seq,
          "select_date": opt_obj.select_date,
        });
      }
    }, 100);
  };
  const close_write_diary_page = () => {
    set_content_tab("calendar");
    StuSearchListRef.current.list({
      now_page: 1,
      s_seq: [],
    });
  };

  return (
    <CompLayout isConTitle={false}>
      <SearchArea
        listOpt={stu_list_opt}
        setListOpt={(inData: any) => {
          if (StuSearchListRef.current) {
            StuSearchListRef.current.setListOpt(inData);
            set_stu_list_opt(inData);
          }
        }}
        list={(inData: any) => {
          if (StuSearchListRef.current) {
            StuSearchListRef.current.list(inData);
            set_stu_list_opt({
              ...stu_list_opt,
              ...inData
            });
          }
        }}
        is_show_add_btn={true}
        add_btn_text={
          <>
            <span style={{ fontSize: "20px" }}>
              +
            </span>
            <span className="ml-1" style={{ color: "#31ff31", fontSize: "18px" }}>
              상담등록
            </span>
          </>
        }
        on_click_go_add={() => { navigate("/comp/basic/counsel/list"); }}
      ></SearchArea>
      <div className={Style.wrap}>
        <div className={Style.left_box} ref={left_box_ref}>
          <div ref={left_box_scroll_ref}>
            <FindStudentList
              ref={StuSearchListRef}
              show_key_arr={["row_view_recent_councel"]}
              grid_opt={{
                is_add_checkbox: true,
                rowMultiSelectWithClick: false,
                height: window.innerHeight - 140,
                domLayout: "normal",
              }}
              is_use_paging={false}
              listOpt={{
                s_addon_add_memo: "1",
                // s_addon_counsel_todo_tot: "1",
                // s_addon_counsel_start_date: DateFunc.get_date_format(DateFunc.get_change_date(new Date(), 'month', -1), "Y-m-01"),
                // s_addon_counsel_end_date: DateFunc.get_date_format(DateFunc.get_change_date(new Date(), 'month', +1), "Y-m-t"),
              }}
              is_show_search_area={false}
              title_center_str={(
                <div style={{textAlign:"right",flexGrow:1,marginRight:10}}>
                  <button className="btn btn-yellowish2"
                    onClick={() => { open_write_counsel_todo({}); }}>+예약등록</button>
                </div>
              )}
              list={(inData: any) => {
                if (inData.s_stu_user_seq != undefined) {
                  CalendarAreaRef.current.list({ s_stu_seq: inData.s_stu_user_seq });
                }

                if (inData.select_stu_info_arr) {
                  set_select_stu_arr(inData.select_stu_info_arr);
                  if (WriteCounselTodoAreaRef.current) {
                    WriteCounselTodoAreaRef.current.setInitData({
                      stu_info_arr: inData.select_stu_info_arr,
                    });
                  }
                }
              }}
            ></FindStudentList>
          </div>
        </div>
        <div className={Style.cal_box} >
          <div ref={cal_box_ref}>
            {content_tab == "calendar" &&
              <CalendarArea
                ref={CalendarAreaRef}
                onSearchDateChange={onSearchDateChange}
                go_search_user_list={go_search_user_list}
                show_write_counsel_todo={open_write_counsel_todo}
                open_view_counsel_todo={open_view_counsel_todo}
                show_write_diary_page={show_write_diary_page}
              ></CalendarArea>
            }
            {content_tab == "stu_info" &&
              <StuInfoArea
                ref={StuInfoAreaRef}
                close_write_diary_page={close_write_diary_page}
              ></StuInfoArea>
            }
            {content_tab == "write_counsel_todo" &&
              <WriteCounselTodoArea
                ref={WriteCounselTodoAreaRef}
                is_show_title={true}
                title_str={"상담일정 등록"}
                is_show_close_btn={false}
                is_show_find_stu_btn={false}
                closePopup={() => { set_content_tab("calendar"); }}
                callback={() => {
                  if (CalendarAreaRef.current) {
                    CalendarAreaRef.current.list({});
                  }
                  go_search_user_list({});
                }}
                stu_info_arr={select_stu_arr}
              ></WriteCounselTodoArea>
            }
          </div>
        </div>
      </div>
      <RightScrollFix
        right_ref={left_box_scroll_ref}
        limit_scroll_top={290}
      ></RightScrollFix>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} title_bar_style={{ borderBottom: 0 }}
        >
          {popupData.sort == "write_ctodo" &&
            <WriteCounselTodoPopup
              stu_info_arr={popupData.stu_info_arr}
              start_date={popupData.start_date}
              end_date={popupData.end_date}
              callback={() => { CalendarAreaRef.current.list({}); go_search_user_list({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></WriteCounselTodoPopup>
          }
          {popupData.sort == "view_ctodo" &&
            <ViewCounselTodoOfDay
              select_date={popupData.select_date}
              stu_info_arr={popupData.stu_info_arr}
              list_opt={popupData.list_opt}
              show_write_diary_page={show_write_diary_page}
              callback={() => { CalendarAreaRef.current.list({}); go_search_user_list({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></ViewCounselTodoOfDay>
          }
        </LayerPopup>
      }
    </CompLayout>
  );
}

export default CounselCalendarPage;